import { Rotationsplan } from '@/domain/mitarbeiter/features/rotationsplan/entities/Rotationsplan';

export function checkIfMitarbeiterHasRotationsplan(
  mitarbeiterId: string,
  rotationsplaene: Rotationsplan[],
): boolean {
  return rotationsplaene.some((r) => r.mitarbeiter.id === mitarbeiterId);
}
